import React from 'react';
import './App.css';
import './theme.css';
import Header from './components/Header';
import Hero from './components/Hero';
import {Marquee, About} from './components/AboutMarquee';
import Services from './components/Services';
import BridalSlider from './components/BridalSlider';
import {Why, Gallery} from './components/WhyGallery';
import {Packages, HairSkinCare} from './components/PackagesCare';
import {Testimonials, FAQ} from './components/Testimonials';
import {Contact, FinalCTA, Footer, FloatingWhatsApp} from './components/ContactFooter';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <BridalSlider />
        <Why />
        <Gallery />
        <Packages />
        <HairSkinCare />
        <Testimonials />
        <FAQ />
        <Contact />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}

export default App;
